import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import * as mutationTypes from './mutation-types';
import { IState, HealthListParam, ContentParam } from './types';
import { getList, getListSearch, getContent } from '../api/index';
import { getVoteList } from '@/api/api';

const state: IState = {
  healthList: [],
  detailData: {},
  finished: false,
  loading: false,
  page: 1,
  searchPage: 1,
  button: true,
  loadStatus: 0,
  contentData: '',
  coverImg: '',
};

const mutations: MutationTree<IState> = {
  [mutationTypes.GET_HEALTH_LIST](state, healthList) {
    state.healthList = [...state.healthList, ...healthList];
  },
  [mutationTypes.GET_DETAIL_DATA](state, detail) {
    state.detailData = detail;
    state.contentData = detail.content.replace(/<p>/g, '');
    state.coverImg = detail.cover[0];
    // state.contentData = detail.content.replace(/</p>/g, '');
  },
  [mutationTypes.UPDATE_VOTENUMBER](state, val: any) {
    state.voteNum = Number(state.voteNum) + 1;
    state.detailData.votes = Number(state.detailData.votes) + 1;
    state.button = false;
  },
  [mutationTypes.CLEAN_LIST_DATA](state) {
    state.page = 1;
    state.searchPage = 1;
    state.healthList = [];
    state.finished = false;
  },
  [mutationTypes.CHANGE_LOADSTATUS_DATA](state) {
    state.loadStatus = 0;
  },
};

const actions: ActionTree<IState, any> = {
  async gethealthList({ commit, state }, param: HealthListParam) {
    state.loadStatus = 0;
    state.loading = true;
    const result = await getList(param);
    state.page++;
    state.loading = false;
    if ((result as any).msg === '暂无数据' || (result as any).code === 500) {
      return (state.finished = true);
    }
    commit(mutationTypes.GET_HEALTH_LIST, result.data);
  },
  async searchHealthList({ commit, state }, param: HealthListParam) {
    state.loadStatus = 1;
    state.loading = true;
    const result = await getListSearch(param);
    state.searchPage++;
    state.loading = false;
    if ((result as any).msg === '暂无数据' || (result as any).code === 500) {
      return (state.finished = true);
    }
    commit(mutationTypes.GET_HEALTH_LIST, result.data);
  },
  changehealthType({ commit, state }, index: number) {
    console.log('changehealthType', index);
    state.page = 1;
    state.healthList = [];
    state.finished = false;
  },
  // 详情页数据
  async getDetail({ commit, state }, param: ContentParam) {
    const res = await getContent(param);
    commit(mutationTypes.GET_DETAIL_DATA, res.data);
  },
  // 伪更新
  updateVoteNumber({ commit }, val) {
    commit(mutationTypes.UPDATE_VOTENUMBER, val);
    setTimeout(() => {
      state.button = true;
    }, 2000);
  },
};

const HealthContributionBrand2019: Module<IState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default HealthContributionBrand2019;
